<template>
  <div class="dashboard-widget-content dashboard-widget-content--text">
    <template v-if="!value.ShowOptions">
      <template v-if="options.track == 'all'">
        <div class="md-layout">
          <div class="md-layout-item">
            <div class="widget-text-row"><b>{{ $t('widget.SMPPActivity.partner') }}</b></div>
            <template v-if="partners.length == 0">
              <div class="widget-text-row">{{ $t('widget.SMPPActivity.no_data') }}</div>
            </template>
            <template v-else>
              <template v-if="inactivePartners.length == 0">
                <div class="text-success widget-text-row"><b>{{ $t('widget.SMPPActivity.status.active') }}</b></div>
              </template>
              <template v-else>
                <div class="text-danger widget-text-row"><b>{{ $t('widget.SMPPActivity.status.inactive') }}</b></div>
                <template v-if="fullSize">
                  <div v-for="item in inactivePartners" :key="item.name" class="text-danger widget-text-row">{{ item.name }}</div>
                </template>
                <template v-else>
                  <div v-for="item in inactivePartnersSliced" :key="item.name" class="text-danger widget-text-row">{{ item.name }}</div>
                  <div v-if="inactivePartners.length > show_count" class="widget-text-row">{{ $t('widget.options.more') }} {{ inactivePartners.length - show_count }}</div>
                </template>
              </template>
            </template>
          </div>
          <div class="md-layout-item">
            <div class="widget-text-row"><b>{{ $t('widget.SMPPActivity.service_provider') }}</b></div>
            <template v-if="service_providers.length == 0">
              <div class="widget-text-row">{{ $t('widget.SMPPActivity.no_data') }}</div>
            </template>
            <template v-else>
              <template v-if="inactiveServiceProviders.length == 0">
                <div class="text-success widget-text-row"><b>{{ $t('widget.SMPPActivity.status.active') }}</b></div>
              </template>
              <template v-else>
                <div class="text-danger widget-text-row"><b>{{ $t('widget.SMPPActivity.status.inactive') }}</b></div>
                <template v-if="fullSize">
                  <div v-for="item in inactiveServiceProviders" :key="item.name" class="text-danger widget-text-row">{{ item.name }}</div>
                </template>
                <template v-else>
                  <div v-for="item in inactiveServiceProvidersSliced" :key="item.name" class="text-danger widget-text-row">{{ item.name }}</div>
                  <div v-if="inactiveServiceProviders.length > show_count" class="widget-text-row">{{ $t('widget.options.more') }} {{ inactiveServiceProviders.length - show_count }}</div>
                </template>
              </template>
            </template>
          </div>
        </div>
      </template>
      <template v-else-if="options.track == 'partner'">
        <div class="md-layout-item">
          <div class="widget-text-row"><b>{{ $t('widget.SMPPActivity.partner') }}</b></div>
          <template v-if="partners.length == 0">
            <div class="widget-text-row">{{ $t('widget.SMPPActivity.no_data') }}</div>
          </template>
          <template v-else>
            <template v-if="inactivePartners.length == 0">
              <div class="text-success widget-text-row"><b>{{ $t('widget.SMPPActivity.status.active') }}</b></div>
            </template>
            <template v-else>
              <div class="text-danger widget-text-row"><b>{{ $t('widget.SMPPActivity.status.inactive') }}</b></div>
              <template v-if="fullSize">
                <div v-for="item in inactivePartners" :key="item.name" class="text-danger widget-text-row">{{ item.name }}</div>
              </template>
              <template v-else>
                <div v-for="item in inactivePartnersSliced" :key="item.name" class="text-danger widget-text-row column">{{ item.name }}</div>
                <div v-if="inactivePartners.length > show_count" class="widget-text-row column">{{ $t('widget.options.more') }} {{ inactivePartners.length - show_count }}</div>
              </template>
            </template>
          </template>
        </div>
      </template>
      <template v-else-if="options.track == 'service_provider'">
        <div class="md-layout-item">
          <div class="widget-text-row"><b>{{ $t('widget.SMPPActivity.service_provider') }}</b></div>
          <template v-if="service_providers.length == 0">
            <div class="widget-text-row">{{ $t('widget.SMPPActivity.no_data') }}</div>
          </template>
          <template v-else>
            <template v-if="inactiveServiceProviders.length == 0">
              <div class="text-success widget-text-row"><b>{{ $t('widget.SMPPActivity.status.active') }}</b></div>
            </template>
            <template v-else>
              <div class="text-danger widget-text-row"><b>{{ $t('widget.SMPPActivity.status.inactive') }}</b></div>
              <template v-if="fullSize">
                <div v-for="item in inactiveServiceProviders" :key="item.name" class="text-danger widget-text-row">{{ item.name }}</div>
              </template>
              <template v-else>
                <div v-for="item in inactiveServiceProvidersSliced" :key="item.name" class="text-danger widget-text-row column">{{ item.name }}</div>
                <div v-if="inactiveServiceProviders.length > show_count" class="widget-text-row column">{{ $t('widget.options.more') }} {{ inactiveServiceProviders.length - show_count }}</div>
              </template>
            </template>
          </template>
        </div>
      </template>
    </template>
    <template v-else>
      <widget-options>
        <md-field>
          <label>{{ $t('widget.options.update') }}</label>
          <md-select v-model="options.update">
            <md-option value="1">1 {{ $t('widget.options.min') }}</md-option>
            <md-option value="10">10 {{ $t('widget.options.min') }}</md-option>
            <md-option value="0">{{ $t('widget.options.no') }}</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.track') }}</label>
          <md-select v-model="options.track">
            <!-- <md-option value="all">{{ $t('widget.SMPPActivity.options.tracks.all') }}</md-option> -->
            <!-- <md-option value="partner">{{ $t('widget.SMPPActivity.options.tracks.partner') }}</md-option> -->
            <md-option value="service_provider">{{ $t('widget.SMPPActivity.options.tracks.service_provider') }}</md-option>
          </md-select>
        </md-field>
      </widget-options>
    </template>
  </div>
</template>

<script>
  import widgetMixin from './mixin'
  import {PartnerConnectons, ServiceProviderConnectons} from "@/services/Widgets";

  export default {
    mixins:[widgetMixin],
    name: "SMPPActivity",
    props:{
      value:{},
      fullSize:{default:false}
    },
    data(){return{
      options:{
        update:'1',
        track:'all',
      },
      show_count: 5,
      timer: null,
      partners: [],
      service_providers: [],
    }},
    computed: {
      inactivePartners() {
          return this.partners.filter((item) => item.status === 0)
      },
      inactivePartnersSliced() {
          return this.inactivePartners.slice(0, this.show_count)
      },
      inactiveServiceProviders() {
          return this.service_providers.filter((item) => item.status === 0)
      },
      inactiveServiceProvidersSliced() {
        return this.inactiveServiceProviders.slice(0, this.show_count);
      }
    },
    methods: {
      title() {
        return this.$t(`widget.${this.value.name}.title`);
      },
      async getData() {
        let response;

        if (this.options.track == 'all' || this.options.track == 'partner') {
          response = await PartnerConnectons();
          if (response.data) {
            this.partners = response.data.connections;
          }
        }

        if (this.options.track == 'all' || this.options.track == 'service_provider') {
          response = await ServiceProviderConnectons();
          if (response.data) {
            this.service_providers = response.data.connections;
          }
        }
      },
      intervalFunc() {
        clearInterval(this.timer);
        const update = (60000 * parseInt(this.options.update)) || 0;
        if (update > 0) {
          this.getData();
          this.timer = setInterval(() => this.getData(), update);
        }
        this.show_count = this.options.track == 'all' ? this.show_count : this.show_count*2;
      }
    },
    watch: {
      'options'() {
        this.intervalFunc();
      }
    },
    mounted() {
      this.intervalFunc();
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
</script>

<style>
.widget-text-row.column {
  display: inline-block;
  width: 50%;
}
</style>
